import { GET_ACTIVE_REQUESTS_DELEGATIONS } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const getActiveRequestsDelegationsActions = (data) => {
    return {
        type: GET_ACTIVE_REQUESTS_DELEGATIONS,
        payload: data,
    }
}
